import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

function MenuButton({ children, open, location, item }) {
    const linkButton = () => {
        return (
            <>
                <ListItemButton
                    href={item.path}
                    sx={[
                        {
                            minHeight: 48,
                            px: 2.5,
                        },
                        open
                            ? {
                                justifyContent: 'initial',
                            }
                            : {
                                justifyContent: 'center',
                            },
                        "/" + location.pathname.split("/")[1] === item.path ? {
                            backgroundColor: '#e96726',
                            color: 'black'
                        } :
                            {
                                backgroundColor: 'inherit',
                                color: 'inherit'
                            }
                    ]}
                >
                    {children}
                </ListItemButton>
            </>
        )
    };

    const clickButton = () => {
        return (
            <>
                <ListItemButton
                    onClick={item.onclick}
                    sx={[
                        {
                            minHeight: 48,
                            px: 2.5,
                        },
                        open
                            ? {
                                justifyContent: 'initial',
                            }
                            : {
                                justifyContent: 'center',
                            },
                        "/" + location.pathname.split("/")[1] === item.path ? {
                            backgroundColor: '#e96726',
                            color: 'black'
                        } :
                            {
                                backgroundColor: 'inherit',
                                color: 'inherit'
                            }
                    ]}
                >
                    {children}
                </ListItemButton>
            </>
        )
    };

    if (item.path) {
        return (
            <>
                {linkButton()}
            </>
        )
    } else {
        return (
            <>
                {clickButton()}
            </>
        )
    }
}

export default MenuButton;